import React from 'react';
import { IMember } from 'types';
import { useTranslation } from 'react-i18next';
import { formatCPF } from '../../../utils/formatCPF';

const ProfileMobile = ({ created, birthdate, email, cpf }: Partial<IMember>) => {
  const { t } = useTranslation('corpClubProfile');

  return (
    <div className="body-profile-data-container-mobile">
      <div className="body-profile-data-container-mobile-date">
        <span>{t('included_date_title')}</span>
        <p>{created}</p>
      </div>
      <div className="body-profile-data-container-mobile-cpf">
        <span>{t('cpf_title')}</span>
        <p>{formatCPF(cpf || '')}</p>
      </div>
      <div className="body-profile-data-container-mobile-email">
        <span>{t('email_title')}</span>
        <p>{email}</p>
      </div>
      <div className="body-profile-data-container-mobile-birthday">
        <span>{t('birthday_title')}</span>
        <p>{birthdate}</p>
      </div>
    </div>
  );
};

export default ProfileMobile;
